import ajax from "../../lib/appfuse-react/core/ajax";

const satisfactionSurveyService = {

    /* For student */
    find: async () => {
        const response = await ajax.get('qnrClasses/myQnrs');
        return response.data;
    },
    complete: async (id, data) => {
        const response = await ajax.post(`qnrClasses/${id}/complete`, data);
        return response.data;
    },

    /* For lecturer */
    // 學員滿意度
    findStudent: async () => {
        const response = await ajax.get("qnrClasses/mySatisfactions");
        return response.data;
    }

}

export default satisfactionSurveyService;